import { Assignment } from '@mui/icons-material';

import { basicRoles } from '@/router/consts';
import { 원스톱_솔루션_라우터, 원스톱_솔루션_라우터_루트 } from '@/router/one-stop-solution/routes';
import type { SidebarMenu } from '@/router/types';

export const 원스톱_솔루션_사이드바_메뉴들: SidebarMenu[] = [
  {
    title: 원스톱_솔루션_라우터.index.handle.title,
    path: 원스톱_솔루션_라우터.index.path,
    icon: <Assignment />,
    roles: basicRoles,
    childrenMenus: [
      ...원스톱_솔루션_라우터_루트
        .filter(v => v.handle.displayInSidebarMenu === true)
        .map((v): SidebarMenu => {
          return {
            title: v.handle.title,
            path: v.path,
            display: true,
          };
        }),
    ],
  },
];
